import * as React from "react";
function SvgFunnelPencil(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M17.46 24.66l.21 3.34H14V14.85L5.26 3.9l22.21.1-3.22 4.46 1.62 1.17L31.38 2l-30.3-.12L12 15.55V30h7.25a1.32 1.32 0 00.34 0h.17l.19-.07L23.16 27l5.6-13.65-5.7-2.35zm8.69-10.22l-4.67 11.37-1.84 1.64-.16-2.45 4.67-11.37z" />
      <path d="M19.59 30h-.34a1.32 1.32 0 00.34 0z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnelPencil);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
